jQuery(document).ready(function($) {

    $( ".bloc_hdp" ).each(function( index ) {

        let bloc = this
        let tl = gsap.timeline({ defaults: { ease: "power3.out" } })

        // Éléments
        let h1 = bloc.querySelector("h1")
        let accroche = bloc.querySelector(".accroche")

        // États initiaux
        if (h1) {
            let sourireEl = h1.querySelector(".sourire")
            if (sourireEl) sourireEl.remove()

            let splitH1 = new SplitText(h1, { type: "lines", linesClass: "hdp-line" })
            gsap.set(splitH1.lines, { opacity: 0, y: 40 })

            if (sourireEl) h1.appendChild(sourireEl)
        }
        if (accroche) {
            let splitAccroche = new SplitText(accroche, { type: "lines", linesClass: "accroche-line" })
            gsap.set(splitAccroche.lines, { opacity: 0, y: 30 })
        }


        // Timeline d'apparition
        // 1 — Titre h1 : animation par lignes
        if (h1) {
            let h1Lines = bloc.querySelectorAll(".hdp-line")
            tl.to(h1Lines, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.15,
                ease: "power3.out"
            }, 0.7)
        }

        // 2 — Accroche : animation par lignes
        if (accroche) {
            let accrocheLines = bloc.querySelectorAll(".accroche-line")
            tl.to(accrocheLines, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.12,
                ease: "power3.out"
            }, 1.1)
        }

    })

});